import React from 'react';
import LocationTemplate from './LocationTemplate';

const FuquayVarinaPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Fuquay-Varina"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27526"]}
      latitude={35.5843}
      longitude={-78.8000}
      population={34152}
      historicalFact="Unique hyphenated name from the merger of Fuquay Springs and Varina in 1963."
      nearbyTowns={[
        "Holly Springs, NC",
        "Apex, NC",
        "Garner, NC",
        "Raleigh, NC",
        "Cary, NC",
        "Clayton, NC",
        "Angier, NC",
        "Lillington, NC"
      ]}
    />
  );
};

export default FuquayVarinaPage;